import React, { useEffect, useState } from "react";
import Container from "../../style/container";
import { Button, Result, Spin } from "antd";
import { useNavigate, useSearchParams } from "react-router-dom";
import {
  applyActionCode,
  checkActionCode,
  sendEmailVerification,
} from "firebase/auth";
import { auth } from "../../firebase.config";

const EmailVerificationPage = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const oobCode = searchParams.get("oobCode");

  const [confirmed, setConfirmed] = useState(false);
  const [expired, setExpired] = useState(false);
  const [loading, setLoading] = useState(true);
  const [resent, setResent] = useState(false);
  const [resendError, setResendError] = useState(null);

  useEffect(() => {
    if (oobCode) {
      checkActionCode(auth, oobCode)
        .then(() => applyActionCode(auth, oobCode))
        .then(() => {
          setConfirmed(true);
        })
        .catch((err) => {
          console.error("Verification error:", err.message);
          setExpired(true);
        })
        .finally(() => {
          setLoading(false);
        });
    } else {
      setLoading(false);
    }
  }, [oobCode]);

  const handleResend = async () => {
    if (!auth.currentUser) {
      setResendError("You need to login first.");
      return;
    }

    try {
      await sendEmailVerification(auth.currentUser);
      setResent(true);
    } catch (err) {
      console.error("Resend failed:", err.message);
      setResendError(err.message);
    }
  };

  if (loading) {
    return (
      <Container>
        <Spin size="large" style={{ marginTop: "10rem" }} />
      </Container>
    );
  }

  return (
    <Container>
      <Result
        status={confirmed ? "success" : expired ? "error" : "info"}
        title={
          confirmed
            ? "Your email has been successfully verified!"
            : expired
            ? "Verification link is invalid or expired."
            : "Please check your inbox and verify your email."
        }
        subTitle={
          confirmed
            ? "You can now login to your dashboard."
            : expired
            ? "The verification link is no longer valid."
            : "Click the link in your email to verify. Please check your spam folder if you don't see it. Didn't receive it?"
        }
        extra={[
          confirmed ? (
            <Button
              type="primary"
              key="login"
              onClick={() => navigate("/signin")}
            >
              Login
            </Button>
          ) : (
            <>
              <Button
                type="primary"
                key="resend"
                onClick={handleResend}
                disabled={resent}
              >
                {resent
                  ? "Verification Email Sent"
                  : "Resend Verification Email"}
              </Button>
              {resendError && (
                <div style={{ color: "red", marginTop: 8 }}>{resendError}</div>
              )}

              <Button
                type="secondary"
                key="login"
                onClick={() => navigate("/signin")}
                style={{ backgroundColor: "#333", color: "#fff" }}
              >
                Login
              </Button>
            </>
          ),
        ]}
      />
    </Container>
  );
};

export default EmailVerificationPage;
